import { render, staticRenderFns } from "./Comingsoon.vue?vue&type=template&id=59b459ef&"
import script from "./Comingsoon.vue?vue&type=script&lang=js&"
export * from "./Comingsoon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports